import httpClient from "@/_shared/http-client";
import { objectHelper, httpHelper } from "@/_shared/utils";

import responseAdapter from "@/business/api-services/_responseAdapter";
import requestAdapter from "@/business/api-services/_requestAdapter";
import urlBuilder from "@/business/api-services/_urlBuilder";

const getProvider = async (id = 1) => {
  let results = {};
  const url = urlBuilder.buildForContactForm(id);
  await httpClient
    .get(url)
    .then(({ data }) => (
      results = responseAdapter.adaptForContactForm(data, 'provider')
    ));
  return results;
};

const handleProvider = (httpMethod = 'post') => async (body = {}, products = {}) => {
  body = objectHelper.createCopy(body);
  body.type = 'provider';
  body.data = httpHelper.addDateField(body.provider, httpMethod);
  delete body.provider;
  body.products = requestAdapter.adaptProviderProducts(products);
  const url = new URL(`${process.env.BACKEND_URL}/business/contacts`);
  const response = await httpClient[httpMethod](url, body).catch(({ response }) => {
    throw new Error(response.data.message)
  });;
  return response;
};

export const providerService = {
  edit: handleProvider('patch'),
  add: handleProvider('post'),
  get: (id) => getProvider(id),
};



// WEBPACK FOOTER //
// ./src/business/api-services/providerService.js